export default __webpack_public_path__ + "static/media/ph.3eff2364.PNG";